import { render, staticRenderFns } from "./NotificationConfig.vue?vue&type=template&id=523f949e&scoped=true"
import script from "./NotificationConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationConfig.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f949e",
  null
  
)

export default component.exports